export const constants = {
    "navWidth": "280px"
}